import * as React from "react";
import "./index.css";
import * as ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { CartProvider } from "./CartContext";

import App from "./App";
import Layout from "./layouts/Layout";
import AuthLayout from "./auth/Layout";
import Buy from "./pages/buy/index";
import Group from "./pages/customer/group";
import GroupManagement from "./pages/customer/group_management";
import UserList from "./pages/buy/customer_list";
import Reports from "./pages/reports/index";
import ReportsDaily from "./pages/reports/table/daily_sales_summary";
import SalesSummary from "./pages/reports/table/sales_summary";
import PurchasesSummary from "./pages/reports/table/purchases_summary";
import DailyPurchasesSummary from "./pages/reports/table/daily_purchases_summary";
import DashBoard from "./pages/reports/index";
// import ReportDetail from "./pages/reports/Detail";
import ReportDetail from "./pages/buy/components/report_summary_detail";
import Receipt from "./pages/receipt/receipt";
import BuyCheckout from "./pages/buy/buy";
import Equipment from "./pages/equipment";
import Home from "./pages/Home";
import reportWebVitals from "./reportWebVitals";
import Login from "./auth/Login";
import Register from "./auth/Register";
import CustomerForm from "./pages/customer/create";
import CustomerEdit from "./pages/customer/edit";
import TicketList from "./pages/ticket/ticket_list";
import Sale from "./pages/sale/index";
import SaleUserList from "./pages/saleCustomer/customer_list";
import SaleCheckout from "./pages/sale/sale";
import SaleTicketList from "./pages/ticket/sale_ticket_list";
import CustomerList from "./pages/customer/customer_list";
import PoManagement from "./pages/po";
import PoCreate from "./pages/po/create";
import PoEdit from "./pages/po/edit";
import SoManagement from "./pages/so";
import SoCreate from "./pages/so/create";
import SoEdit from "./pages/so/edit";
import Transform from "./pages/transform";
import Exchange from "./pages/transform/exchange";
import Stock from "./pages/stock";
import Inventory from "./pages/inventory";
import LockPricing from "./pages/lockPricing";

import RequirePermission from "./auth/RequirePermission";
import { AuthProvider } from "./contexts/AuthContext";
import IndividualPurchasesSummary from "./pages/reports/table/summary_individual_purchases";
import SummaryPurchasesProduct from "./pages/reports/table/summary_purchases_product";
import SummaryTicketPurchase from "./pages/reports/table/summary_ticket_purchases";
import CostInventory from "./pages/reports/table/cost_inventory";
import DailySalesSummary from "./pages/reports/table/daily_sales_summary";
import IndividualSalesSummary from "./pages/reports/table/summary_individual_sales";
import SummarySalesProduct from "./pages/reports/table/summary_sales_product";
import SummaryTicketSales from "./pages/reports/table/summary_ticket_sales";
import TopMonthlySalesPage from "./pages/reports/table/topMonthlySalesPage";
import SalesQuotaReport from "./pages/reports/table/sales_quota";
import TopMonthlyPurchasesPage from "./pages/reports/table/TopMonthlyPurchasesPage";
import PurchasePrice from "./pages/reports/purchasePrice";

import SaleCustomerList from "./pages/sale/customer_list";
import SaleCustomerCreate from "./pages/saleCustomer/create";
import SaleCustomerEdit from "./pages/saleCustomer/edit";
import EditButton from "./pages/editButton/index";

const router = createBrowserRouter([
  {
    Component: App,
    children: [
      {
        path: "/",
        Component: Layout,
        children: [
          {
            path: "/",
            Component: Home,
          },
          {
            path: "/customers/create",
            Component: () => (
              <RequirePermission permission={[]}>
                <CustomerForm />
              </RequirePermission>
            ),
          },
          {
            path: "/customers/edit",
            Component: () => (
              <RequirePermission permission={[]}>
                <CustomerEdit />
              </RequirePermission>
            ),
          },
          {
            path: "/buy",
            Component: () => (
              <RequirePermission permission={[]}>
                <Buy />
              </RequirePermission>
            ),
          },
          {
            path: "/buy/customers",
            Component: () => (
              <RequirePermission permission={[]}>
                <UserList />
              </RequirePermission>
            ),
          },
          {
            path: "/buy/checkout",
            Component: () => (
              <RequirePermission permission={[]}>
                <BuyCheckout />
              </RequirePermission>
            ),
          },
          {
            path: "/buy/ticket",
            Component: () => (
              <RequirePermission permission={[]}>
                <TicketList />
              </RequirePermission>
            ),
          },
          {
            path: "/sale",
            Component: () => (
              <RequirePermission permission={[]}>
                <Sale />
              </RequirePermission>
            ),
          },
          {
            path: "/sale/customers",
            Component: () => (
              <RequirePermission permission={[]}>
                <SaleCustomerList />
              </RequirePermission>
            ),
          },
          {
            path: "/sale-customers",
            Component: () => (
              <RequirePermission permission={[]}>
                <SaleUserList />
              </RequirePermission>
            ),
          },
          {
            path: "/sale-customers/create",
            Component: () => (
              <RequirePermission permission={[]}>
                <SaleCustomerCreate />
              </RequirePermission>
            ),
          },
          {
            path: "/sale-customers/edit",
            Component: () => (
              <RequirePermission permission={[]}>
                <SaleCustomerEdit />
              </RequirePermission>
            ),
          },
          {
            path: "/sale/checkout",
            Component: () => (
              <RequirePermission permission={[]}>
                <SaleCheckout />
              </RequirePermission>
            ),
          },
          {
            path: "/sale/ticket",
            Component: () => (
              <RequirePermission permission={[]}>
                <SaleTicketList />
              </RequirePermission>
            ),
          },
          {
            path: "/customers",
            Component: () => (
              <RequirePermission permission={["customer_manage"]}>
                <CustomerList />
              </RequirePermission>
            ),
          },
          {
            path: "/customer_group",
            Component: () => (
              <RequirePermission permission={[]}>
                <Group />
              </RequirePermission>
            ),
          },
          {
            path: "/customer_group/:group_id",
            Component: () => (
              <RequirePermission permission={[]}>
                <GroupManagement />
              </RequirePermission>
            ),
          },
          {
            path: "/reports",
            Component: () => (
              <RequirePermission
                permission={["report_purchase_items", "report_sale_items"]}
              >
                <Reports />
              </RequirePermission>
            ),
          },
          {
            path: "/reports/daily",
            Component: () => (
              <RequirePermission permission={[]}>
                <Buy />
              </RequirePermission>
            ),
          },
          {
            path: "/reports/sales",
            Component: () => (
              <RequirePermission permission={[]}>
                <SalesSummary />
              </RequirePermission>
            ),
          },
          {
            path: "/reports/daily_purchases",
            Component: () => (
              <RequirePermission permission={[]}>
                <DailyPurchasesSummary />
              </RequirePermission>
            ),
          },
          {
            path: "/reports/individual_purchases",
            Component: () => (
              <RequirePermission permission={[]}>
                <IndividualPurchasesSummary />
              </RequirePermission>
            ),
          },
          {
            path: "/reports/summary_purchases_product",
            Component: () => (
              <RequirePermission permission={[]}>
                <SummaryPurchasesProduct />
              </RequirePermission>
            ),
          },
          {
            path: "/reports/summary_ticket_purchases",
            Component: () => (
              <RequirePermission permission={[]}>
                <SummaryTicketPurchase />
              </RequirePermission>
            ),
          },
          {
            path: "/reports/cost_inventory",
            Component: () => (
              <RequirePermission permission={[]}>
                <CostInventory />
              </RequirePermission>
            ),
          },
          {
            path: "/reports/daily_sales",
            Component: () => (
              <RequirePermission permission={[]}>
                <DailySalesSummary />
              </RequirePermission>
            ),
          },
          {
            path: "/reports/individual_sales",
            Component: () => (
              <RequirePermission permission={[]}>
                <IndividualSalesSummary />
              </RequirePermission>
            ),
          },
          {
            path: "/reports/summary_sales_product",
            Component: () => (
              <RequirePermission permission={[]}>
                <SummarySalesProduct />
              </RequirePermission>
            ),
          },
          {
            path: "/reports/summary_ticket_sales",
            Component: () => (
              <RequirePermission permission={[]}>
                <SummaryTicketSales />
              </RequirePermission>
            ),
          },
          {
            path: "/reports/purchases",
            Component: () => (
              <RequirePermission permission={[]}>
                <PurchasesSummary />
              </RequirePermission>
            ),
          },
          {
            path: "/reports/purchases/:transactionId",
            Component: () => (
              <RequirePermission permission={[]}>
                <ReportDetail />
              </RequirePermission>
            ),
          },
          {
            path: "/reports/top_monthly_sales",
            Component: () => (
              <RequirePermission permission={[]}>
                <TopMonthlySalesPage />
              </RequirePermission>
            ),
          },
          {
            path: "/reports/sales_quota",
            Component: () => (
              <RequirePermission permission={[]}>
                <SalesQuotaReport />
              </RequirePermission>
            ),
          },
          {
            path: "/reports/top_monthly_purchases",
            Component: () => (
              <RequirePermission permission={[]}>
                <TopMonthlyPurchasesPage />
              </RequirePermission>
            ),
          },
            {
            path: "/reports/purchase_price",
            Component: () => (
              <RequirePermission permission={[]}>
                <PurchasePrice />
              </RequirePermission>
            ),
          },
          {
            path: "/dashboard",
            Component: () => (
              <RequirePermission permission={[]}>
                <DashBoard />
              </RequirePermission>
            ),
          },
          {
            path: "/equipment",
            Component: () => (
              <RequirePermission permission={[]}>
                <Equipment />
              </RequirePermission>
            ),
          },
          {
            path: "/po_management",
            Component: () => (
              <RequirePermission permission={[]}>
                <PoManagement />
              </RequirePermission>
            ),
          },
          {
            path: "/po_management/po_create",
            Component: () => (
              <RequirePermission permission={[]}>
                <PoCreate />
              </RequirePermission>
            ),
          },
          {
            path: "/po_management/po_edit",
            Component: () => (
              <RequirePermission permission={[]}>
                <PoEdit />
              </RequirePermission>
            ),
          },
          {
            path: "/so_management",
            Component: () => (
              <RequirePermission permission={[]}>
                <SoManagement />
              </RequirePermission>
            ),
          },
          {
            path: "/so_management/so_create",
            Component: () => (
              <RequirePermission permission={[]}>
                <SoCreate />
              </RequirePermission>
            ),
          },
          {
            path: "/so_management/so_edit",
            Component: () => (
              <RequirePermission permission={[]}>
                <SoEdit />
              </RequirePermission>
            ),
          },
          {
            path: "/lock_pricing",
            Component: () => (
              <RequirePermission permission={[]}>
                <LockPricing />
              </RequirePermission>
            ),
          },
          {
            path: "/stock",
            Component: () => (
              <RequirePermission permission={[]}>
                <Stock />
              </RequirePermission>
            ),
          },
          {
            path: "/stock/inventory",
            Component: () => (
              <RequirePermission permission={[]}>
                <Inventory />
              </RequirePermission>
            ),
          },
          {
            path: "/stock/transform",
            Component: () => (
              <RequirePermission permission={[]}>
                <Transform />
              </RequirePermission>
            ),
          },
          {
            path: "/stock/transform/exchange",
            Component: () => (
              <RequirePermission permission={[]}>
                <Exchange />
              </RequirePermission>
            ),
          },
          {
            path: "/edit_button",
            Component: () => (
              <RequirePermission permission={[]}>
                <EditButton />
              </RequirePermission>
            ),
          },
        ],
      },
    ],
  },
  {
    path: "/auth",
    Component: AuthLayout,
    children: [
      {
        path: "login",
        Component: Login,
      },
      {
        path: "register",
        Component: Register,
      },
    ],
  },
  {
    path: "/",
    Component: AuthLayout,
    children: [
      {
        path: "/receipt/:transactionId",
        Component: Receipt,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
    <CartProvider>
      <RouterProvider router={router} />
    </CartProvider>
  </AuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
